__turbopack_context__.v({
  "button": "login-form-module__OCbxpa__button",
  "error": "login-form-module__OCbxpa__error",
  "field": "login-form-module__OCbxpa__field",
  "forget": "login-form-module__OCbxpa__forget",
  "formWrapper": "login-form-module__OCbxpa__formWrapper",
  "social": "login-form-module__OCbxpa__social",
  "submit": "login-form-module__OCbxpa__submit",
  "wrapper": "login-form-module__OCbxpa__wrapper",
});
